<!-- Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. -->
<div class="sign-up-container" *ngIf="{ isAuthed: isAuthed$ | async } as vm">
	<div>
		<h1>{{ appStrings.SIGN_UP_TITLE }}</h1>
		<p>{{ appStrings.SIGN_UP_SUBTITLE }}</p>
		<password-policy-list *ngIf="!vm.isAuthed" class="password-policy-mobile"></password-policy-list>
		<form class="signup-container" [formGroup]="signUpForm" (ngSubmit)="onSave()">
			<div class="display-wrap">
				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_FIRST_NAME }}</mat-label>
					<input matInput autocomplete="firstName" formControlName="firstName" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_LAST_NAME }}</mat-label>
					<input matInput autocomplete="lastName" formControlName="lastName" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<mat-form-field>
					<mat-label>{{ appStrings.EMAIL }}</mat-label>
					<input matInput autocomplete="username" formControlName="email" />
					<mat-error *ngIf="email.hasError('email')">{{ appStrings.ENTER_VALID_EMAIL }}</mat-error>
					<mat-error *ngIf="email.hasError('required')">{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_TELEPHONE }}</mat-label>
					<input matInput autocomplete="phone" formControlName="phone" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<ng-container formGroupName="passwords" *ngIf="!vm.isAuthed">
					<mat-form-field>
						<mat-label>{{ appStrings.SIGN_UP_FORM_PASSWORD }}</mat-label>
						<input
							type="password"
							matInput
							autocomplete="password"
							formControlName="password"
							[errorStateMatcher]="passwordErrorMatcher"
						/>
						<mat-error *ngIf="password.hasError('required')">{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
						<mat-error *ngIf="!password.hasError('required') && password.hasError('minlength')">{{
							appStrings.PASSWORD_ERROR_MIN
						}}</mat-error>
						<mat-error
							*ngIf="
								!password.hasError('required') &&
								!password.hasError('minlength') &&
								password.hasError('notMatchRequirements')
							"
							>{{ appStrings.PASSWORD_ERROR_PATTERN }}</mat-error
						>
					</mat-form-field>

					<mat-form-field>
						<mat-label>{{ appStrings.SIGN_UP_FORM_CONFIRM_PASSWORD }}</mat-label>
						<input
							type="password"
							[errorStateMatcher]="confirmPasswordErrorMatcher"
							matInput
							autocomplete="confirmPassword"
							formControlName="confirmPassword"
						/>
						<mat-error *ngIf="confirmPassword.hasError('required')">{{
							appStrings.FIELD_IS_REQUIRED
						}}</mat-error>
						<mat-error
							*ngIf="!confirmPassword.hasError('required') && passwords.hasError('passwordNotMatch')"
							>{{ appStrings.CONFIRM_PASSWORD_ERROR }}</mat-error
						>
					</mat-form-field>
				</ng-container>

				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_COMPANY }}</mat-label>
					<input matInput autocomplete="company" formControlName="company" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<mat-extended-select
					[option$]="titleFields$"
					[valuePath]="['value']"
					placeholder="Select a title"
					formControlName="title"
					[required]="true"
				>
				</mat-extended-select>
			</div>
			<div class="terms">
				<mat-checkbox formControlName="terms">
					<span class="terms-text"
						>I accept the <a [href]="serviceTermsLink" target="_">Terms & Conditions</a></span
					>
				</mat-checkbox>
				<mat-error *ngIf="terms.dirty && terms.hasError('required')">
					{{ appStrings.TERMS_CONDITIONS_MUST_BE_ACCEPTED }}
				</mat-error>
			</div>
			<tp-form-auto-error></tp-form-auto-error>
			<button-footer [saveOrCloseButtonText]="appStrings.SIGN_UP_NEXT_BTN">
				<button
					type="button"
					leftButton
					*ngIf="!(appState.user | async)"
					(click)="onCancel()"
					mat-stroked-button
					color="primary"
				>
					{{ appStrings.SIGN_UP_CANCEL_BTN }}
				</button>
			</button-footer>
		</form>
	</div>
	<password-policy-list *ngIf="!vm.isAuthed" class="password-policy-desktop"></password-policy-list>
</div>
